export const getCustomUserColumn = (id, apiId, colName, colAttrs, isVisibleForExternals = false, selected = false) => {
	return {
		id: id !== null ? id : window.crypto.randomUUID(),
		apiId: apiId,
		labels: colName,
		label: colName,
		twoLineBreak: true,
		isChecked: selected,
		isCustom: true,
		propName: 'custom',
		attributes: colAttrs,
		sortable: false,
		isVisibleForExternals: isVisibleForExternals
	};
};
